import global from "./global.json";

export const es = {
  global,
};
